<ng-container>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Event Details</h5>
    </div>
    <div class="modal-body" *ngIf="!initialized">
      <page-load-header></page-load-header>
    </div>
    <div class="modal-body" *ngIf="initialized">
      <div class="row">
        <!-- <div class="col-md-3">
          <img class="img-fluid rounded-circle mr-1" src="fetch-avatar?userId={{ evt.instructor.id }}&width=200&height=200&mode=Crop"  />
        </div> -->
        <div class="col-md-12">
          <h4>{{ evt.title }}</h4>

          <!-- <strong class="d-block">{{ evt.instructor.fullNameWithCredentials }}</strong> -->
          <!-- <strong class="d-block">{{ user.organizationalTitle }}</strong> -->
          <!-- <strong class="d-block"
            ><a href="mailto:{{ user.email }}"> {{ user.email }}</a>
          </strong> -->
          <!-- <strong class="d-block">{{ user.phoneNumber | phone }}</strong> -->
        </div>
      </div>
      <div class="row mt">
        <div class="col">
          <div class="d-md-flex align-items-md-center">
            <!-- Location -->
            <div class="pr-4 mb-3 mb-md-0 mr-4">
              <h2 class="small text-secondary mb-0">{{ 'date' | translate }}</h2>
              <small class="fas fa-calendar-alt text-secondary align-middle mr-1"></small>
              <span class="align-middle">{{ evt.startTime | date }}</span>
              <small class="fas fa-clock text-secondary align-middle mr-1 ml-2"></small>
              <span class="align-middle"
              >{{ evt.startTime | date: 'shortTime' }} - {{ evt.endTime | date: 'shortTime' }}
                <strong>{{ timezone }}</strong></span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <h2 class="small text-secondary mb-1 mt-1">CEUs</h2>

          <bxl-ceu-display [CEUs]="evt.ceus"></bxl-ceu-display>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <ul class="list-inline font-size-1 text-muted">
            <li class="list-inline-item">
              <a class="font-size-1 d-block mb-1">
                <img class="img-fluid rounded-circle" style="width: 50px" [fallback]="'fetch-avatar?userId=' + evt.instructor.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ evt.instructor.id }}-avatar.png"/>
                {{ evt.instructor.fullNameWithCredentials }}
                <span *ngIf="evt.instructor.pronouns"> ({{ evt.instructor.pronouns }})</span>
              </a>
              <ng-container *ngFor="let instructor of evt.coInstructors">
                <a *ngIf="!instructor.hidden" class="font-size-1 d-block mb-1">
                  <img class="img-fluid rounded-circle" style="width: 50px" [fallback]="'fetch-avatar?userId=' + instructor.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ instructor.id }}-avatar.png"/>
                  {{ instructor.fullNameWithCredentials }}
                  <span *ngIf="instructor.pronouns"> ({{ instructor.pronouns }})</span>
                </a>
              </ng-container>
            </li>
          </ul>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col"></div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <div [editorHTML]="evt.description"></div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row ml-auto">
        <div class="col-md-12">
          <button class="btn btn-sm btn-outline-dark ml-auto" (click)="onCancel()" type="button">Close</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
